import { Components, Theme } from "@mui/material";

export const ButtonStyle = (theme: Theme): Pick<Components, "MuiButton"> => {
  const { spacing } = theme;
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          maxHeight: spacing(6.25),
          margin: 0,
          fontSize: "11px",
          color: "#000",
        },
      },
    },
  };
};
